import "./gallery.css";
import { useState, useRef, useEffect } from "react";
import img1 from "../../assets/galleryAssets/1.jpg";
import img2 from "../../assets/galleryAssets/2.jpg";
import img3 from "../../assets/galleryAssets/3.jpg";
import img4 from "../../assets/galleryAssets/4.jpg";
import img5 from "../../assets/galleryAssets/5.jpg";
import img6 from "../../assets/galleryAssets/6.jpg";
import img7 from "../../assets/galleryAssets/7.jpg";
import img8 from "../../assets/galleryAssets/8.jpg";
import img9 from "../../assets/galleryAssets/9.jpg";
import img10 from "../../assets/galleryAssets/10.jpg";
import img11 from "../../assets/galleryAssets/11.jpg";
import img12 from "../../assets/galleryAssets/12.jpg";
import img13 from "../../assets/galleryAssets/13.jpg";
import img14 from "../../assets/galleryAssets/14.jpg";
import video from "../../assets/galleryAssets/WhatsApp Video 2025-09-25 at 08.39.27_02676e2b.mp4";
import video2 from "../../assets/galleryAssets/vid-2.mp4";

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const trackRef = useRef(null);
  const slideRefs = useRef([]);

  const galleryItems = [
    { type: "image", src: img1, alt: "Img-1" },
    { type: "image", src: img2, alt: "Img-2" },
    { type: "image", src: img3, alt: "Img-3" },
    { type: "image", src: img4, alt: "Img-4" },
    { type: "image", src: img5, alt: "Img-5" },
    { type: "image", src: img6, alt: "Img-6" },
    { type: "image", src: img7, alt: "Img-7" },
    { type: "image", src: img8, alt: "Img-8" },
    {
      type: "video",
      src: video,
      alt: "School Video",
    },
    { type: "image", src: img9, alt: "Img-9" },
    { type: "image", src: img10, alt: "Img-10" },
    { type: "image", src: img11, alt: "Img-11" },
    { type: "image", src: img12, alt: "Img-12" },
    { type: "image", src: img13, alt: "Img-13" },
    { type: "image", src: img14, alt: "Img-14" },
    {
      type: "video",
      src: video2,
      alt: "School Video",
    },
  ];

  // Calculate how many slides to show based on screen width
  const getSlidesToShow = () => {
    if (window.innerWidth < 768) return 1;
    if (window.innerWidth < 1024) return 2;
    return 3;
  };

  const [slidesToShow, setSlidesToShow] = useState(getSlidesToShow());

  useEffect(() => {
    const handleResize = () => {
      setSlidesToShow(getSlidesToShow());
      // Reset to first slide on resize to avoid layout issues
      setCurrentIndex(0);
      if (trackRef.current) {
        trackRef.current.style.transform = `translateX(0px)`;
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (trackRef.current && slideRefs.current.length > 0) {
      const slideWidth = slideRefs.current[0].offsetWidth + 20; // 20px gap
      const newPosition = -currentIndex * slideWidth;
      trackRef.current.style.transform = `translateX(${newPosition}px)`;
    }
  }, [currentIndex, slidesToShow]);

  const nextSlide = () => {
    if (currentIndex < galleryItems.length - slidesToShow) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handlePlayButtonClick = (index) => {
    const videoElement = document.getElementById(`video-${index}`);
    const playButton = document.getElementById(`play-button-${index}`);

    if (videoElement && playButton) {
      if (videoElement.paused) {
        videoElement.play();
        playButton.style.display = "none";
      } else {
        videoElement.pause();
        playButton.style.display = "flex";
      }
    }
  };

  return (
    <div className="gallery-container">
      <h2>Gallery</h2>
      <p className="gallery-text">
        Explore our vibrant learning environment and student achievements.
      </p>

      <div className="gallery-slider">
        <div className="gallery-track" ref={trackRef}>
          {galleryItems.map((item, index) => (
            <div
              key={index}
              className="slide"
              ref={(el) => (slideRefs.current[index] = el)}
            >
              {item.type === "image" ? (
                <img src={item.src} alt={item.alt} />
              ) : (
                <div className="video-container">
                  <video
                    id={`video-${index}`}
                    controls
                    onPlay={() => {
                      const playButton = document.getElementById(
                        `play-button-${index}`
                      );
                      if (playButton) playButton.style.display = "none";
                    }}
                    onPause={() => {
                      const playButton = document.getElementById(
                        `play-button-${index}`
                      );
                      if (playButton) playButton.style.display = "flex";
                    }}
                  >
                    <source src={item.src} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <div
                    id={`play-button-${index}`}
                    className="play-button"
                    onClick={() => handlePlayButtonClick(index)}
                  >
                    <span>▶</span>
                  </div>
                </div>
              )}
              <div className="slide-caption">{item.caption}</div>
            </div>
          ))}
        </div>

        <div className="slider-nav">
          <button
            className="nav-btn prev-btn"
            onClick={prevSlide}
            disabled={currentIndex === 0}
          >
            &#10094;
          </button>
          <button
            className="nav-btn next-btn"
            onClick={nextSlide}
            disabled={currentIndex >= galleryItems.length - slidesToShow}
          >
            &#10095;
          </button>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
